import React, { useState, useEffect } from "react";
import {
	Autocomplete,
	TextField,
	FormControl,
	Box,
	Select,
	MenuItem,
	InputLabel,
	CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { generateClient } from "aws-amplify/api";
import { seasonsBySeriesId } from "../../graphql/queries";
import CreateSeason from "./CreateSeason";
import { setSelectedSeasonsList } from "../../redux/slices/contentSlice/contentForm/contentForm";
import CreateAndUploadSeason from "./CreateAndUploadSeason";

const Seasons = ({ formik }) => {
	const dispatch = useDispatch();
	const client = generateClient();
	const seriesID = useSelector((state) => state.contentForm.seriesID);
	const seasonCreated = useSelector(
		(state) => state.batchContentHandler.seasonCreated
	);

	const [seasonsList, setSeasonsList] = useState([]);
	const [selectedSeasons, setSelectedSeasons] = useState([]);
	const [selectedSeason, setSelectedSeason] = useState("");
	const [loading, setLoading] = useState(false);

	const fetchSeasonsBySeriesID = async (seriesID) => {
		try {
			setLoading(true);
			const response = await client.graphql({
				query: seasonsBySeriesId,
				variables: {
					seriesId: seriesID,
				},
			});
			const list = response.data.seasonsBySeriesId.items;
			setSeasonsList(list);
		} catch (error) {
			console.error(
				`Error fetching seasons for series ID ${seriesID}:`,
				error
			);
			setSeasonsList([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (seriesID) {
			fetchSeasonsBySeriesID(seriesID);
		}
	}, [seriesID, seasonCreated]);

	useEffect(() => {}, [formik.values.SeasonId]);
	// const handleChange = (event, newValue) => {
	//   dispatch(setSelectedSeasonsList(newValue));
	//   console.log(newValue);
	//   setSelectedSeasons(newValue);
	// };
	const handleChange = (event, value) => {
		console.log(value, "selectedSeasons");
		setSelectedSeasons(value);
		dispatch(setSelectedSeasonsList(value));
	};

	return (
		<Box display={"flex"} gap={1} alignItems={"flex-end"}>
			<FormControl fullWidth variant="outlined">
				<label
					style={{ margin: "10px 0", textWrap: "nowrap" }}
					htmlFor={"select-seasons"}
				>
					Select Seasons
					<span style={{ color: "red", marginLeft: "5px" }}>*</span>
				</label>
				{loading ? (
					<CircularProgress />
				) : (
					<Autocomplete
						multiple
						id="select-seasons"
						options={seasonsList}
						getOptionLabel={(option) => option.title}
						onChange={(e, value) => handleChange(e, value)}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="outlined"
								placeholder="Seasons"
							/>
						)}
					/>
				)}
			</FormControl>
			{/* <CreateSeason /> */}
			<CreateAndUploadSeason />
		</Box>
	);
};

export default Seasons;
